import React, { useEffect, useState } from 'react'
import Header from './global/Header'
import Footer from './global/Footer'
import '../assets/css/style.css'
import Dashboard from './Dashboard'
import ModalSlider from './ModalSlider'
import axios from 'axios'
import { baseUrl } from '../consts/consts'

const DetailsPage = () => {
  const [modalShow, setModalShow] = React.useState(true)
  const [popupData, setPopupData] = useState([])
  const [loader, setLoader] = useState(false)

  const getPopupData = async () => {
    setLoader(true)
    try {
      const { data } = await axios.get(
        `${baseUrl}/settings/popup-banner/guest-lecture`
      )

      const sortedData = data.data
      sortedData.sort((a, b) => a.order - b.order)

      setPopupData(sortedData)
      setLoader(false)
    } catch (error) {
      console.log(error.response)
      setLoader(false)
    }
  }

  useEffect(() => {
    getPopupData()
  }, [])

  useEffect(() => {
    if (localStorage.getItem('guestlectureopen')) {
      setModalShow(false)
    } else {
      localStorage.setItem('guestlectureopen', true)
    }
  }, [])
  window.onbeforeunload = function () {
    localStorage.clear()
  }
  return (
    <>
      <Header />
      {popupData.length > 0 && (
        <ModalSlider
          show={modalShow}
          onHide={() => setModalShow(false)}
          popupData={popupData}
          loader={loader}
        />
      )}
      <section style={{ background: '#f2faff' }}>
        <Dashboard></Dashboard>
        <Footer />
      </section>
    </>
  )
}

export default DetailsPage
